import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"menu\">\n  <g fill=\"currentColor\" transform=\"translate(40 175)\">\n    <rect width=\"400\" height=\"25\" rx=\"12.5\" />\n    <rect width=\"262.5\" height=\"25\" y=\"125\" rx=\"12.5\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol